import React, {
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, Box, TextField } from '@mui/material';
import { useStyles } from './styles';
import useSelectedOption from '../../../../utils/hooks/useSelectedOption';
import { inputDataCustom } from '../../../../utils/custom_prop_types/customPropTypes';
import Loader from '../../../commons/Loader';

export default function PanelSection({
  loader,
  panels,
  panelsInput,
  setPanelsInput,
  inputData,
  fetchProductsBySection,
  handlePanelSelectChange,
}) {
  const [panelsArray, setPanelsArray] = useState([]);
  const classes = useStyles();
  const selectedOption = useSelectedOption(panelsArray, inputData.panelIRI);

  useEffect(() => {
    fetchProductsBySection({
      section: 'panel',
    });
  }, []);

  useEffect(() => {
    setPanelsArray([]);
    const tempArray = [];

    panels['hydra:member']?.forEach((panel) => {
      tempArray.push({
        description: panel.description,
        compare: panel['@id'],
        iri: panel['@id'],
        value: panel.productGroup.number,
      });

      setPanelsArray(tempArray);
    });
  }, [panels]);

  return (
    <Box className={classes.inputWrapper}>
      <Autocomplete
        disabled={loader.panels}
        autoHighlight
        ListboxProps={{ style: { maxHeight: '15rem' } }}
        className={classes.panels}
        getOptionLabel={(option) => option.description}
        disableClearable
        options={panelsArray}
        value={selectedOption}
        inputValue={panelsInput}
        onChange={(_, value) => handlePanelSelectChange(value)}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            label="Panels"
            color="secondary"
            variant="standard"
            onChange={(event) => setPanelsInput(event.target.value)}
          />
        )}
      />
      <Loader target="panels" offsetRight={48} size={18} centeredY />
    </Box>
  );
}

PanelSection.propTypes = {
  loader: PropTypes.objectOf(PropTypes.bool).isRequired,
  panels: PropTypes.objectOf(PropTypes.any).isRequired,
  panelsInput: PropTypes.string.isRequired,
  setPanelsInput: PropTypes.func.isRequired,
  inputData: inputDataCustom.isRequired,
  handlePanelSelectChange: PropTypes.func.isRequired,
  fetchProductsBySection: PropTypes.func.isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
};
